var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 12,
    viewBox: "0 0 12 12",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 1.41667c-.46024 0-.83333.37309-.83333.83333s.37309.83333.83333.83333.83333-.37309.83333-.83333-.37309-.83333-.83333-.83333zm-1.25.83333c0-.69036.55964-1.25 1.25-1.25s1.25.55964 1.25 1.25-.55964 1.25-1.25 1.25-1.25-.55964-1.25-1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 5.16667c-.46024 0-.83333.37309-.83333.83333s.37309.83333.83333.83333.83333-.37309.83333-.83333-.37309-.83333-.83333-.83333zm-1.25.83333c0-.69036.55964-1.25 1.25-1.25s1.25.55964 1.25 1.25-.55964 1.25-1.25 1.25-1.25-.55964-1.25-1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 8.91667c-.46024 0-.83333.37309-.83333.83333 0 .4602.37309.8333.83333.8333s.83333-.3731.83333-.8333c0-.46024-.37309-.83333-.83333-.83333zm-1.25.83333c0-.69036.55964-1.25 1.25-1.25s1.25.55964 1.25 1.25c0 .6904-.55964 1.25-1.25 1.25s-1.25-.5596-1.25-1.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalMenu);
export default __webpack_public_path__ + "static/media/vertical_menu.48a4ae5ee6a4a6ba161ef071fdeedb43.svg";
export { ForwardRef as ReactComponent };